module.exports = __webpack_public_path__ + "static/media/info.776b3f85.svg";